// ----------------------------------------------------------------------

const nofifications = [
  {
    id: 1,
    title: 'titletitle',
    description: 'descdesc',
    datefull: '2022-01-16 18:47 UTC',
    status: 'Active'
  },
  {
    id: 2,
    title: 'titletitle2',
    description: 'descdesc2',
    datefull: '2022-01-16 18:47 UTC',
    status: 'Active'
  }
];

export default nofifications;
